import {Text, VStack} from '@chakra-ui/react'

import {space} from 'config/theme'
import Header from 'components/header'
import TeamGrid from 'components/team-grid'

import Main from 'layouts/main'

const teamDescription =
  'The Conveyal team offers a unique combination of skills and knowledge bridging software engineering and urban planning, with extensive experience in the development and application of high quality, user-centered tools for open transport data collection, management, analysis, and visualization for clients around the world. We maintain active connections to the transportation research community, publishing our methods in peer-reviewed journals and attending scientific conferences to stay informed and contribute to the state of the art.'

export default function AboutPage() {
  return (
    <Main title='About us'>
      <Header>About us</Header>
      <VStack p={space.lg} spacing={space.lg}>
        <Text fontWeight='normal' size='md' maxW='60ch'>
          {teamDescription}
        </Text>
        <TeamGrid />
      </VStack>
    </Main>
  )
}
